import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "container-fluid text-light py-4",
  style: {"background-color":"var(--primary-color)"}
}
const _hoisted_2 = { class: "row d-flex flex-row align-items-center" }
const _hoisted_3 = { class: "col col-12 col-md-6" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = {
  key: 0,
  class: "",
  style: {"color":"var(--warning)"}
}
const _hoisted_6 = { class: "px-2" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col col-12 col-md-6 ps-md-5" }, [
        _createElementVNode("h2", { style: {"font-weight":"bold"} }, "Don't miss a thing"),
        _createElementVNode("p", null, "Subscribe To Our Newsletter")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
          class: "d-flex flex-row py-2 justify-content-between",
          style: {"background-color":"var(--primary-color-transparent)"}
        }, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-control",
              style: {"background-color":"var(--primary-color-transparent)","border":"none","color":"var(--light)"},
              id: "emailInput",
              placeholder: "Your email address",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            (
              !$options.validateEmail && _ctx.email != null && _ctx.email.length > 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Please enter a valid email address "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-light",
              disabled: !$options.validateEmail || !_ctx.termsAndConditionsAndPrivacyPolicy,
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.newsletterSignUp()))
            }, " Subscribe ", 8, _hoisted_7)
          ])
        ], 32)
      ])
    ])
  ]))
}